<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('monitor.logininfor.loginAddress')">
                <a-input v-model="queryParam.ipaddr" :placeholder="$t('monitor.logininfor.inputLoginAddress')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('monitor.logininfor.useStatus')">
                <a-select :placeholder="$t('monitor.logininfor.useStatus')" v-model="queryParam.status" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in sysCommonStatusOptions" :key="index" :value="d.value">{{
                    d.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('monitor.logininfor.loginName')">
                  <a-input v-model="queryParam.loginName" :placeholder="$t('monitor.logininfor.inputLoginName')" style="width: 100%" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('monitor.logininfor.loginTime')">
                  <a-range-picker style="width: 100%" v-model="dateRange" valueFormat="YYYY-MM-DD" format="YYYY-MM-DD"
                    allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {}">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('common.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('common.reset') }}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('system.collapse') : $t('system.expand') }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-space :wrap="true">
          <a-button type="dashed" :disabled="single" @click="handleUnlock" v-hasPermi="['monitor:logininfor:unlock']">
            <a-icon type="unlock" />{{ $t('monitor.logininfor.unlock') }}
          </a-button>
          <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['monitor:logininfor:remove']">
            <a-icon type="delete" />{{ $t('common.delete') }}
          </a-button>
          <a-button type="danger" @click="handleClean" v-hasPermi="['monitor:logininfor:remove']">
            <a-icon type="delete" />{{ $t('monitor.operlog.clean') }}
          </a-button>
          <a-button type="primary" @click="handleExport" v-hasPermi="['system:logininfor:export']">
            <a-icon type="download" />{{ $t('common.export') }}
          </a-button>
          <table-setting
            :table-size.sync="tableSize"
            v-model="columns"
            :refresh-loading="loading"
            @refresh="getList" />
        </a-space>
      </div>
      <!-- 数据展示 -->
      <a-table :loading="loading" :size="tableSize" rowKey="infoId" :columns="columns" :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :pagination="false"
        @change="handleTableChange" :bordered="tableBordered" :scroll="{ x: 'max-content' }">
        <span slot="status" slot-scope="text, record">
          <dict-tag :options="sysCommonStatusOptions" :value="record.status" />
        </span>

        <span slot="loginLocation" slot-scope="text, record">
          {{ record.loginLocation && record.loginLocation.includes('null') ? $t('monitor.logininfor.unknownLocation') : record.loginLocation }}
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
        :total="total" :page-size="queryParam.pageSize" :showTotal="total => $t('table.total', { total })"
        @showSizeChange="onShowSizeChange" @change="changeSize" />
    </a-card>
  </page-header-wrapper>
</template>

<script>

import { list, delLogininfor, cleanLogininfor, unlockLogininfor } from '@/api/monitor/logininfor'
import { tableMixin } from '@/store/table-mixin'
import { translateDictOptions } from '@/utils/dictI18n'

export default {
  name: 'Logininfor',
  components: {
  },
  mixins: [tableMixin],
  dicts: ['sys_common_status'],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      loading: false,
      single: true,
      selectName: '',
      multiple: true,
      ids: [],
      total: 0,
      dateRange: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        ipaddr: null,
        loginName: undefined,
        status: undefined
      }
    }
  },
  created () {
    this.getList()
  },
  computed: {
    sysCommonStatusOptions () {
      const _locale = this.$i18n.locale
      return translateDictOptions(this.dict.type.sys_common_status, 'sys_common_status', this.$t.bind(this))
    },
    columns () {
      return [
        {
          title: this.$t('monitor.logininfor.infoId'),
          dataIndex: 'infoId',
          align: 'center'
        },
        {
          title: this.$t('monitor.logininfor.userName'),
          dataIndex: 'userName',
          align: 'center'
        },
        {
          title: this.$t('monitor.logininfor.loginAddress'),
          dataIndex: 'ipaddr',
          align: 'center'
        },
        {
          title: this.$t('monitor.logininfor.loginLocation'),
          dataIndex: 'loginLocation',
          scopedSlots: { customRender: 'loginLocation' },
          align: 'center'
        },
        {
          title: this.$t('monitor.logininfor.browser'),
          dataIndex: 'browser',
          align: 'center'
        },
        {
          title: this.$t('monitor.logininfor.os'),
          dataIndex: 'os',
          align: 'center'
        },
        {
          title: this.$t('system.status'),
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: this.$t('monitor.logininfor.operMsg'),
          dataIndex: 'msg',
          align: 'center'
        },
        {
          title: this.$t('monitor.logininfor.loginTime'),
          dataIndex: 'loginTime',
          align: 'center',
          sorter: true
        }
      ]
    }
  },
  methods: {
    handleTableChange (pagination, filters, sorter) {
      const sort = this.tableSorter(sorter)
      this.queryParam.orderByColumn = sort.orderByColumn
      this.queryParam.isAsc = sort.isAsc
      this.getList()
    },
    getList () {
      this.loading = true
      list(this.addDateRange(this.queryParam, this.dateRange)).then(response => {
        if (response.success) {
          this.list = response.data.records
          this.total = response.data.total
          this.loading = false
        }
      })
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.dateRange = []
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        ipaddr: null,
        loginName: undefined,
        status: undefined
      }
      this.handleQuery()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.infoId)
      this.multiple = !selectedRowKeys.length
      this.single = selectedRowKeys.length !== 1
      if (this.single) {
        this.selectName = this.selectedRows.map(item => item.userName)
      }
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleDelete (row) {
      const that = this
      const infoIds = row.infoId || this.ids
      this.$confirm({
        title: this.$t('system.confirmDelete'),
        content: this.$t('monitor.logininfor.confirmDeleteContent', { ids: infoIds }),
        onOk () {
          return delLogininfor(infoIds)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(that.$t('common.deleteSuccess'), 3)
            })
        },
        onCancel () { }
      })
    },
    handleClean () {
      const that = this
      this.$confirm({
        title: this.$t('monitor.logininfor.confirmClean'),
        content: this.$t('monitor.logininfor.confirmCleanContent'),
        onOk () {
          return cleanLogininfor()
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(that.$t('monitor.operlog.cleanSuccess'), 3)
            })
        },
        onCancel () { }
      })
    },
    handleUnlock () {
      const that = this
      const username = this.selectName
      this.$confirm({
        title: this.$t('monitor.logininfor.confirmUnlock', { username }),
        onOk () {
          return unlockLogininfor(username)
            .then(() => {
              that.onSelectChange([], [])
              that.selectName = ''
              that.getList()
              that.$message.success(that.$t('monitor.logininfor.unlockSuccess'), 3)
            })
        },
        onCancel () { }
      })
    },
    handleExport () {
      const that = this
      this.$confirm({
        title: this.$t('system.confirmExport'),
        content: this.$t('system.confirmExportContent'),
        onOk () {
          that.download('monitor/logininfor/export', {
            ...that.queryParam
          }, `logininfor_${new Date().getTime()}.xlsx`)
        },
        onCancel () { }
      })
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/table-responsive.less';
</style>
